import React from "react";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

function ModalEdit({args,toggle, close,isOpen,onChange,onKeyUp,onClick,data,error}) {
  return (
      <Modal isOpen={isOpen} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle} close={close}>
          <span className="t-primary fs-4 fw-bold">Edit</span>
        </ModalHeader>
        <ModalBody className="px-4">
          <div className="w-100">
            <div>
              <label className="mb-2">Categories Name</label>
              <Input
                className="fs-6 border_input rounded w-100"
                type="text"
                onChange={onChange}
                onKeyUp={onKeyUp}
                defaultValue={data.name}
              />
            </div>

            {error.name && <p className="error">{error.name}</p>}
          </div>

          <div className="d-flex justify-content-center mt-4">
            <Button
              className="btn_add w-50"
              onClick={onClick}
            >
              Save
            </Button>
          </div>
        </ModalBody>
      </Modal> 
  );
}

export default ModalEdit;
